import { render, staticRenderFns } from "./relation-list.vue?vue&type=template&id=a235ae56&scoped=true&"
import script from "./relation-list.vue?vue&type=script&lang=js&"
export * from "./relation-list.vue?vue&type=script&lang=js&"
import style0 from "./relation-list.vue?vue&type=style&index=0&id=a235ae56&prod&scoped=true&lang=scss&"
import style1 from "./relation-list.vue?vue&type=style&index=1&id=a235ae56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a235ae56",
  null
  
)

export default component.exports